import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
// import '@/styles/app.css';
import Providers from './app/providers/Providers';
import SettingsContext from './app/contexts/SettingContext';

declare global {
  interface Window {
    __SETTINGS__: {
      site_name: string;
      nickname: string;
      theme: string;
      description: string;
    };
  }
}
const settings = window.__SETTINGS__;
const rootElement = document.getElementById('app');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <SettingsContext.Provider value={settings}>
        <Providers>
          <App />
        </Providers>
      </SettingsContext.Provider>
    </React.StrictMode>
  );
}
